angular.module('main').directive('jobWorkflowProgress', () => ({
	restrict: 'E',
	scope: {
		job: '=snJob'
	},
	template: `<div class="info-box-progress">
                      <div class="progress progress-xs progress-squared bs-n">
                        <div class="progress-bar progress-bar-success {{::barTypesClass}}" role="progressbar"
                          aria-valuenow="10" aria-valuemin="0" aria-valuemax="100" style="width:{{::progressWidth}}">
                        </div>
                      </div>
                    </div>
                    `,
	replace: true,
	transclude: true,
	link(scope) {
		const workflow = angular.copy(scope.job.jobWorkflow);

		scope.progressWidth = `${workflow.countOfCompletedTask /
			workflow.countOfTask *
			100}%`;
		scope.barTypesClass = workflow.progressBarType;
	}
}));



// WEBPACK FOOTER //
// ./web/js/components/PageJobsOverview/jobProgress.js